import React from "react";
import { Outlet } from "react-router-dom";

function NHIC() {
  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
}

export default NHIC;
